<!--更改密码-->
<template>
  <div class="ChangePassword">
    <app-breadcrumb/>
    <div class="page-container account">
      <el-form :inline="true" :model="dataForm" ref="dataForm" size="mini">
        <el-checkbox-group v-model="dataForm.passwordType">
          <el-row>
            <el-col :span="12">
              <div>
                <!--登录密码-->
                <el-checkbox label="userPassword" style="margin-bottom: 20px">
                  {{ $t('sysUser.userPassword') }}
                </el-checkbox>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <!--支付密码-->
                <el-checkbox label="password2" style="margin-bottom: 20px">{{ $t('Common.pay.password') }}</el-checkbox>
              </div>
            </el-col>
          </el-row>
        </el-checkbox-group>
        <el-row>
          <el-col :span="12">
            <div>
              <!--旧密码-->
              <el-form-item :label="$t('sysUser.oldPassword')+':'" prop="oldPassword">
                <el-input size="mini" v-model.trim="dataForm.oldPassword" type="password" show-password/>
              </el-form-item>
              <!--新密码-->
              <el-form-item :label="$t('sysUser.newPassword')+':'" prop="newPassword">
                <el-input size="mini" v-model.trim="dataForm.newPassword" type="password" show-password/>
              </el-form-item>
              <!--重复密码-->
              <el-form-item :label="$t('sysUser.repeatPassword')+':'" prop="repeatPassword">
                <el-input size="mini" v-model.trim="dataForm.repeatPassword" type="password" show-password/>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <!--旧密码-->
              <el-form-item :label="$t('sysUser.oldPassword')+':'" prop="oldPasswordTwo">
                <el-input size="mini" v-model.trim="dataForm.oldPasswordTwo" type="password" show-password/>
              </el-form-item>
              <!--新密码-->
              <el-form-item :label="$t('sysUser.newPassword')+':'" prop="newPasswordTwo">
                <el-input size="mini" v-model.trim="dataForm.newPasswordTwo" type="password" show-password/>
              </el-form-item>
              <!--重复密码-->
              <el-form-item :label="$t('sysUser.repeatPassword')+':'" prop="repeatPasswordTwo">
                <el-input size="mini" v-model.trim="dataForm.repeatPasswordTwo" type="password" show-password/>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <!--验证码-->
        <el-form-item :label="$t('sysUser.validateCode')+':'">
          <el-input size="mini" v-model.trim="dataForm.verifyCode" style="width: 178px"/>
          <el-image fit="contain" :src="captcha.data" @click="handleRefresh"
                    style="width:auto;height:28px;vertical-align: top;border: 1px solid #eeeeee;margin-left: 5px">
            <div slot="error" class="image-slot" @click="handleRefresh">
              <i v-if="captchaLoading" class="el-icon-loading"></i>
              <i v-else class="el-icon-refresh"></i>
            </div>
            <div slot="placeholder" class="image-slot"><i class="el-icon-loading"></i></div>
          </el-image>
        </el-form-item>
        <el-alert :title="$t('tips.password')" type="info" style="margin-bottom: 20px"/>
        <el-form-item style="display: flex;justify-content: center" label-width="0">
          <el-button type="success" :loading="loading" plain icon="el-icon-check" @click="handleFilter">
            {{ $t('button.save') }}
          </el-button>
          <el-button type="danger" :loading="loading" plain icon="el-icon-close" @click="closeBtn">
            {{ $t('operation.button.cancel') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>

import {fetchCaptcha} from "@/api/home";
import {modifyPwd} from "@/api/ay-personal-center/personalcenter"


export default {
  name: "ChangePassword",
  directives: {},
  components: {},
  props: [],
  data() {
    return {
      captcha: {
        data: '',
        key: ''
      },
      loading: false,
      captchaLoading: false,
      checked1: false,
      checked2: false,
      dataForm: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
        oldPasswordTwo: '',
        newPasswordTwo: '',
        repeatPasswordTwo: '',
        captchaKey: "",
        modifyType: "",
        passwordType: [],
        verifyCode: ""
      },
    }
  },
  mounted() {
    this.getCaptcha()
  },
  methods: {
    closeBtn() {
      this.$router.back()
    },
    handleRefresh() {
      if (!this.captchaLoading) {
        this.getCaptcha()
      }
    },
    getCaptcha() {
      this.captchaLoading = true
      this.captcha = {
        data: '',
        key: ''
      }
      fetchCaptcha().then(response => {
        this.captcha = response.data
        this.captchaLoading = false
      }).catch(err => {
        console.warn(err)
        this.captchaLoading = false
      })
    },
    handleFilter() {
      if (!this.dataForm.passwordType.length) {
        return false
      }
      if (this.dataForm.passwordType.includes('userPassword')) {
        if (!this.dataForm.oldPassword) {
          return this.$message.error(this.$t('please.input.oldPassword'))  //请输入旧密码
        }
        if (this.dataForm.newPassword !== this.dataForm.repeatPassword) {
          return this.$message.error(this.$t('error.password.not.accord'))  //两次输入的密码不一致,请重新输入并确认
        }
        if (this.dataForm.newPassword === this.dataForm.oldPassword) {
          return this.$message.error(this.$t('mi.newPwd.difrent.oldPwd'))  //新密码和旧密码不能相同
        }
      }
      if (this.dataForm.passwordType.includes('password2')) {
        if (!this.dataForm.oldPasswordTwo) {
          return this.$message.error(this.$t('please.input.oldPassword'))  //请输入旧密码
        }
        if (this.dataForm.newPasswordTwo !== this.dataForm.repeatPasswordTwo) {
          return this.$message.error(this.$t('error.password.not.accord'))  //两次输入的密码不一致,请重新输入并确认
        }
        if (this.dataForm.newPasswordTwo === this.dataForm.oldPassword) {
          return this.$message.error(this.$t('mi.newPwd.difrent.oldPwd'))  //新密码和旧密码不能相同
        }
      }
      this.loading = true
      this.dataForm.captchaKey = this.captcha.key
      modifyPwd({...this.dataForm}).then(response => {
        this.loading = false
        if (response.success) {
          this.$notify({
            title: '',
            message: '',
            type: 'success'
          })
          if (this.dataForm.passwordType.includes('userPassword')) {
            this.handleLogout()
          }
        }
      }).catch(err => {
        this.loading = false
        console.warn(err)
      })
    },
    async handleLogout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    },
  }
}
</script>
<style scoped>

</style>
